module.exports = __webpack_public_path__ + "images/12-06_57fbe6e8.jpg";